import React from 'react';
import ReactDOM from 'react-dom/client';

import "../node_modules/bootstrap/scss/bootstrap.scss";
import './index.css';
import "./assets/assets/scss/main.scss";
import "./assets/assets/scss/color_skins.scss"; 
import "../node_modules/font-awesome/scss/font-awesome.scss";
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
